import React, { useState, useEffect, useContext, useRef } from 'react';


const AppContext = React.createContext();

const AppProvider = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isContactOpen, setIsContactOpen] = useState(false);
  const [mousePosition, setMousePosition] = useState({
    x: 0,
    y: 0
  });
  const [sectionRef, setSectionRef] = useState({
    about : useRef(null),
    expertise : useRef(null),
    team: useRef(null)
  })
  const [cursorVariant, setCursorVariant] = useState("default");
  const initial = { opacity: 0, scale: 0.5 , y : 200};
  const initialContact = { opacity: 0, scale: 0.2 , y : -200, x : 200};
  const initialSidebar = { x : 500};
  const final = { opacity: 1, scale: 1, y : 0, x : 0 };
  const animation1 = {
    once: true,
    duration: 0.5,
    delay: 0.5,
    ease: [0, 0.71, 0.2, 1.01]
  };

  const animation2 = {
    once: true,
    duration: 0.6,
    delay: 0.8,
    ease: [0, 0.71, 0.2, 1.01]
  };

  const animation3 = {
    once: true,
    duration: 0.6,
    delay: 0.9,
    ease: [0, 0.71, 0.2, 1.01]
  };

  const animation4 = {
    once: true,
    duration: 0.6,
    delay: 1.2,
    ease: [0, 0.71, 0.2, 1.01]
  };

  const animation5 = {
    once: true,
    duration: 0.6,
    delay: 1.4,
    ease: [0, 0.71, 0.2, 1.01]
  };

  const animation6 = {
    once: true,
    duration: 0.6,
    delay: 1.6,
    ease: [0, 0.71, 0.2, 1.01]
  };

  const animation7 = {
    once: true,
    duration: 0.6,
    delay: 1.8,
    ease: [0, 0.71, 0.2, 1.01]
  };

  //mouse animation funtionnality

  useEffect(() => {
    const mouseMove = e => {
      setMousePosition({
        x: e.clientX,
        y: e.clientY
      })
    }

    window.addEventListener("mousemove", mouseMove);

    return () => {
      window.removeEventListener("mousemove", mouseMove);
    }
  }, []);

  useEffect(() => {
    if (isContactOpen) {
      // Block scroll
      document.body.style.overflow = 'hidden';

      // Clean up the effect if needed
      return () => {
        // Unblock scroll
        document.body.style.overflow = 'visible';
      };
    }
  }, [isContactOpen]);
  const variants = {
    default: {
      x: mousePosition.x - 16,
      y: mousePosition.y - 16,
    },
    text: {
      height: 64,
      width: 64,
      x: mousePosition.x - 32,
      y: mousePosition.y - 32,
    },
    button: {
      height: 64,
      width: 64,
      x: mousePosition.x - 32,
      y: mousePosition.y - 32,
      backgroundColor: "#D65A31",
      mixBlendMode: "difference",
    }
  }
  const buttonEnter = () => setCursorVariant("button");
  const textEnter = () => setCursorVariant("text");
  const Leave = () => setCursorVariant("default");

  // sidebar functionality

  const controlSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const openSidebar = () => {
    setIsSidebarOpen(true);
  };
  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  const controlContact = () => {
    setIsContactOpen(!isSidebarOpen);
  };
  const openContact = () => {
    setIsContactOpen(true);
  };
  const closeContact = () => {
    setIsContactOpen(false);
  };

  // Translation

  


  return (
    <AppContext.Provider
      value={{
        setIsSidebarOpen,
        isSidebarOpen,
        openSidebar,
        closeSidebar,
        controlSidebar,
        setIsContactOpen,
        isContactOpen,
        openContact,
        closeContact,
        controlContact,
        variants,
        cursorVariant,
        buttonEnter,
        textEnter,
        Leave,
        initial,
        initialContact,
        initialSidebar,
        final,
        animation1,
        animation2,
        animation3,
        animation4,
        animation5,
        animation6,
        animation7,
        sectionRef,
        setSectionRef
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useGlobalContext = () => {
  return useContext(AppContext);
};

export { AppContext, AppProvider };